document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.category-slider');

  sliders.forEach(function (slider) {
    var wrapper = slider.closest('.category-slider-inner');
    if (!wrapper) return;

    var prevBtn = wrapper.querySelector('.category-slider-arrow.prev');
    var nextBtn = wrapper.querySelector('.category-slider-arrow.next');
    if (!prevBtn || !nextBtn) return;

    // Scroll distance ~ width of a couple items
    function getScrollAmount() {
      var item = slider.querySelector('.category-item');
      var itemWidth = item ? item.offsetWidth : 100;
      return itemWidth * 3;
    }

    function updateArrowState() {
      var maxScroll = slider.scrollWidth - slider.clientWidth;

      // If content doesn't overflow, hide both arrows
      if (maxScroll <= 2) {
        prevBtn.classList.add('is-hidden');
        nextBtn.classList.add('is-hidden');
        return;
      }

      prevBtn.classList.toggle('is-hidden', slider.scrollLeft <= 2);
      nextBtn.classList.toggle('is-hidden', slider.scrollLeft >= maxScroll - 2);
    }

    prevBtn.addEventListener('click', function () {
      slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    slider.addEventListener('scroll', updateArrowState);
    window.addEventListener('resize', updateArrowState);

    updateArrowState();
  });
});